<app-navbar [title]="pageTitle"> </app-navbar>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<app-dynamic-table
	module="dispatcher"
	[elements]="data"
	[tableRows]="tableRows"
	[haveLink]="false"
	[haveFilters]="false"
></app-dynamic-table>
